module.exports = __webpack_public_path__ + "static/media/bell-small.6346dc9e.jpg";